export default __webpack_public_path__ + "static/valicom-e4e2bd52b7716166da1a2b249fb71305.mp4";